export const setToken = (token) => localStorage.setItem("token", token);
export const getToken = () => localStorage.getItem("token");
export const delToken = () => localStorage.removeItem("token");

export function checkToken() {
  let user = getToken();
  if (user !== "") {
    return user;
  } else {
    return null;
  }
}

export function isAuthenticated() {
  return checkToken() !== null;
}
